import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { BoxShadow } from '@r1-frontend/ui-react/tokens/boxShadow';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

const getGradient = (colors: string[]): string => {
    const [leftColor, rightColor] = colors;
    return `linear-gradient(90deg, ${leftColor} 0%, ${rightColor} 100%)`;
};

export const ActiveCardWrapper = styled.div<{ isActive: boolean }>`
    position: relative;
    width: 190px;
    min-height: 180px;
    flex-direction: column;
    flex-wrap: nowrap;
    white-space: pre-wrap;
    text-rendering: geometricPrecision;
    padding: 2px;
    border: ${p => p.isActive ? `3px solid ${COLORS.ButtonPrimary}` : '3px solid transparent'};
    border-radius: 27px;
    transition: all .3s ease;
    user-select: none;

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 148px;
        min-height: 140px;
        border: ${p => p.isActive ? `2px solid ${COLORS.ButtonPrimary}` : '2px solid transparent'};
        border-radius: 19px;
    }

    &:hover {
        box-shadow: ${BoxShadow.S};
    }
`;

export const ArrowPositioner = styled.div<{ isActive: boolean }>`
    visibility: ${p => p.isActive ? 'initial' : 'hidden'};
    position: absolute;
    width: 100%;
    bottom: -24px;
    justify-content: center;
`;

export const TariffCardMinimal = styled.div<{ bg?: string | null, colorText: string | null }>`
    flex-direction: column;
    flex-wrap: nowrap;
    padding: 12px 4px 4px 4px;
    color: ${({ colorText }) => colorText ? colorText : COLORS.TextPrimary};
    background: ${({ bg }) => `${bg}`} 0 0 / cover repeat-y;
    background: image-set(${({ bg }) => `${bg}`} 1x)  0 0 / cover repeat-y;
    background-color: ${({ bg }) => bg};
    border-radius: ${BorderRadius.InnerBlockRadius};
    overflow: hidden;
    z-index: 10;

    @media (max-width: ${wideBreakpoints.mobile}) {
        border-radius: ${BorderRadius.componentRadius};
    }
`;

export const PromoText = styled.h3<{ colors?: Array<string>, hasBg: boolean }>`
    display: block;
    ${FONTS.H5};
    text-transform: uppercase;
    background: ${({ colors }) => colors?.length ? getGradient(colors) : 'none'};
    color: ${({ colors, hasBg }) => colors?.length ? 'transparent' : hasBg ? 'inherit' : COLORS.TextPrimary};
    padding: 0 12px;
    height: 84px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 0 8px;
    }
`;

export const TariffTitle = styled.h3<{ colors?: Array<string>, isSmall?: boolean, hasBg: boolean }>`
    display: block;
    ${({ isSmall }) => isSmall ? css`${FONTS.MediumXXS}` : css`${FONTS.MediumXS}`};
    background: ${({ colors }) => colors?.length ? getGradient(colors) : 'none'};
    color: ${({ colors, hasBg }) => colors?.length ? 'transparent' : hasBg ? 'inherit' : COLORS.TextSecondary};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 12px;
    margin-bottom: 8px;
    
    @media (max-width: ${wideBreakpoints.mobile}) {
      ${({ isSmall }) => isSmall ? css`${FONTS.XXS} font-size: 8px; line-height: 12px;` : css`${FONTS.XXS}`};
      padding: 0 8px;
    }
`;

export const TariffDescription = styled.div<{ colorText: string, bgColor: string, hasBg?: boolean, defaultBg: string }>`
    flex-direction: column;
    min-height: 136px;
    ${FONTS.XS};
    padding: 12px;
    background-color: ${({ bgColor, defaultBg, hasBg }) => bgColor || (hasBg ? 'rgba(255, 255, 255, 0.4)' : defaultBg)};
    border-radius: 22px;
    color: ${({ colorText = COLORS.TextPrimary }) => colorText};

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 12px 8px;
        min-height: 100px;
        border-radius: 14px;

        & > .customSubscriptions{
            margin: 4px -10px 4px !important;
            & > [data-test="right-arrow"] {
              margin-right: 4px;
            }
            & > [data-test="left-arrow"].visible {
              margin-left: 4px;
            }
        }
    }
`;

export const PropsBlock = styled.div`
    flex: 1;
    flex-direction: column;
    justify-content: center;
    min-height: 36px;

    @media (max-width: ${wideBreakpoints.mobile}) {
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      min-height: auto;
    }
`;

export const DescriptionRow = styled.div`
  flex-wrap: nowrap;
  min-height: 20px;

  @media (max-width: ${wideBreakpoints.mobile}) {
    min-height: 16px;
    ${FONTS.XXS};
  }
`;

export const PriceBlock = styled.div`
    flex: 1;
    flex-direction: column;
    justify-content: center;
    min-height: 36px;

    @media (max-width: ${wideBreakpoints.mobile}) {
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      min-height: auto;
    }
`;

export const Price = styled.div`
    ${FONTS.MediumXS};

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.MediumXXS};
    }
`;
export const OldPrice = styled.div<{ hasBg: boolean }>`
    text-decoration: line-through;
    ${FONTS.XXS};

    @media (max-width: ${wideBreakpoints.mobile}) {
        font-size: 8px;
        position: relative;
        top: 1px;
        left: 2px;
    }
`;
